export const capitalize = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const toTitleCase = (str: string): string =>
	str
		.split(/[_\s]+/)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
